import React, { Component } from 'react';
import { Link } from 'gatsby';

import Layout from '../components/Layout';
import Classes from './404.module.css';
import Sidebar from '../components/Sidebar';
import Menubar from '../components/Menubar';
import CardList from '../components/blogs/BlogsList/BlogsList';
import SearchStyle from '../components/blogs/SearchBox/SearchBox.module.css';
import SearchBox from '../components/blogs/SearchBox/SearchBox';
class Blogs extends Component {
  state = {
    cardList: [
      {
        id: 'How to survive in the time of Crisis - YouTube',
        title: 'How to survive in the time of Crisis - YouTube',
        link: 'https://youtu.be/BbRmfxtHUyM/',
        image:
          'https://rany.tk/static/How to survive in the time of Crisis.png',
      },
      {
        id: 'Steps to Allah - Madarij Assalekeen',
        title: 'Steps to Allah - Madarij Assalekeen',
        link:
          'https://www.youtube.com/playlist?list=PLNT8BTFvQYHLmHSeXABFEYS-hZ9IwGdWI',
        image: 'https://iloveallah.net/static/madarej.png',
      },
      {
        id: 'Prepare For Ramadan',
        title: 'Prepare For Ramadan',
        link:
          'https://www.youtube.com/playlist?list=PLNT8BTFvQYHKJMa-hKZvNDe0xgknoHwdY',
        image: 'https://iloveallah.net/static/ramadan.png',
      },
      {
        id: 'Purifying our Hearts - اصلاح القلوب ',
        title: 'Purifying our Hearts - اصلاح القلوب ',
        link:
          'https://www.youtube.com/playlist?list=PLNT8BTFvQYHKJMa-hKZvNDe0xgknoHwdY',
        image: 'https://iloveallah.net/static/ramadan.png',
      },
      {
        id: 'A Journey to Happiness',
        title: 'A Road to Happiness - طريق للسعادة',
        link:
          'https://www.youtube.com/playlist?list=PLNT8BTFvQYHLWc7EkqE0OYo1sRCuQwYzv',
        image: 'https://iloveallah.net/static/happy.png',
      },
      {
        id: 'Can we see Allah - Ihsan',
        title: 'Can we see Allah - Ihsan',
        link:
          'https://www.youtube.com/playlist?list=PLNT8BTFvQYHJs4aTdgLOX7GbOfbx5iilQ',
        image: 'https://iloveallah.net/static/ihsan.png',
      },
    ],
    searchTerm: '',
  };
  render() {
    const { cardList, searchTerm } = this.state;
    const filteredList = cardList.filter(card =>
      card.title.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    return (
      <Layout>
        <Sidebar showTabs="false" />
        <SearchBox
          placeHolder="Search for a video by title"
          changeHandler={e =>
            this.setState({
              searchTerm: e.target.value,
            })
          }
        />
        <CardList list={filteredList} />
      </Layout>
    );
  }
}

export default Blogs;
